<template>
  <div :class="['privacy-policy-content', {
    'sm': sm
  }]">
    <h1 class="heading">
      Sharewind（シェアウィンド）<br>個人情報取扱規定
    </h1>
    <div class="article">
      <div class="article-title">第1条 事業者の名称</div>
      <div class="article-body">岩崎通信機株式会社</div>
    </div>
    <div class="article">
      <div class="article-title">第2条 個人情報保護管理者</div>
      <div class="article-body">岩崎通信機株式会社 取締役執行役員 コーポレート・マネジメント本部長</div>
    </div>
    <div class="article">
      <div class="article-title">第3条 お客様情報及び個人情報</div>
      <div class="article-body">
        <ol>
          <li>お客様情報とは、本サービスを利用するお客様の情報をいいます。</li>
          <li>個人情報とは、お客様情報のうち、氏名、メールアドレス、組織名、所在地、電話番号など、特定の個人を識別することができる情報（当該情報だけでは特定の個人を識別できなくても、他の情報と容易に照合することができ、それにより特定の個人を識別できるものを含みます。）をいいます。</li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第4条 当社が本サービスにおいて取得する情報</div>
      <div class="article-body">
        <div>当社は、本サービスにおいてお客様から次のお客様情報を取得することがあります。ご提供いただけない場合は、本サービスの全部又は一部をご利用いただけない場合があります。</div>
        <ol class="sub right-brackets">
          <li>お客様による本サービスの登録若しくは登録内容の変更又はお客様からの問い合わせ若しくは連絡を通じて直接に取得する情報</li>
          <span>* 必須項目</span>
          <ul class="hyphen">
            <li>氏名*</li>
            <li>メールアドレス*</li>
            <li>会社名*</li>
            <li>電話番号</li>
            <li>ログイン名*</li>
            <li>ログインパスワード*</li>
            <li>評価又は苦情などのお客様からのフィードバック情報</li>
          </ul>
          <li>お客様による本サービスの利用を通じて自動的に取得する情報</li>
          <ul class="hyphen">
            <li>ネットワーク情報</li>
            <li>サービス利用状況に関する情報（例：動作設定の情報、ファイルのアップロード数等）</li>
            <li>本サービスへのアクセス日時</li>
            <li>本サービスを閲覧する際に用いたブラウザの種類並びに閲覧したページ</li>
            <li>本サービスにアクセスするために使用された機器の情報、ハードウェアのモデル、機器のIPアドレス、OSとそのバージョン、選択言語</li>
          </ul>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第5条 お客様情報の利用目的</div>
      <div class="article-body">
        <div>当社は、取得したお客様情報を次の目的で利用します。</div>
        <ol class="sub">
          <li>本サービスに関する登録の受付、本人確認、利用料金の計算等、本サービスの提供、維持、保護及び改善のため</li>
          <li>本サービスの内容に関する情報、アップデート情報、イベント・キャンペーン情報、規約等の変更情報等の告知のため</li>
          <li>本サービスに関するご案内、お問い合わせ等への対応のため</li>
          <li>本サービスに関する当社の規約、その他諸規程に違反する行為への対応のため</li>
          <li>本サービスの利用に関する統計データを作成するため</li>
          <li>今後の本サービスに関する企画、立案又は実施のため</li>
          <li>本サービスを利用する際の、ログイン時又はまたはログイン後の本人認証のため</li>
          <li>キャンペーン等に当選されたお客様に賞品等を発送するため</li>
          <li>その他マーケティングに利用するため</li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第6条 情報の第三者提供</div>
      <div class="article-body">
        <ol>
          <li>当社は、取得したお客様情報のうち個人情報に該当しない情報を、次の場合に第三者に提供することがあります。</li>
          <ol class="sub">
            <li>支払処理、データ分析、カスタマーサービスなど、お客様のご要望に応じたサービスを提供するために、業務提携会社に提供する場合</li>
            <li>本サービスを通じて様々な機能やサービスを提供するため、当社に代わって機能やサービスを提供している第三者に提供する場合</li>
          </ol>
          <li>当社は、取得した個人情報を、次の場合に第三者に提供することがあります。</li>
          <ol class="sub">
            <li>お客様が同意した場合</li>
            <li>お客様が当社の規約に違反し、当社の権利、財産やサービスなどを保護するために、個人情報を公開せざるをえないと判断するに足る十分な根拠がある場合</li>
            <li>人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難である場合</li>
            <li>国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、お客様の同意を得ることによって当該事務の遂行に支障を及ぼすおそれがある場合</li>
            <li>合併、会社分割、事業譲渡その他の事由によって個人情報の提供を含む当社の事業の承継が行われる場合</li>
            <li>個人情報保護法その他の法令で認められる場合</li>
          </ol>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第7条 取得した個人情報の共同利用</div>
      <div class="article-body">
        <div>当社では、グループ各社が持つ経営資源を有機的に組み合わせて、お客様に付加価値の高いサービスを展開することを通じて、グループ全体の企業価値向上を図っております。</div>
        <div>そのため、当社は以下の通り、商品・サービスの販売または提供などに関連してお客様から 取得した個人情報を共同利用させていただきます。</div>
        <ol>
          <li>共同利用する企業の範囲</li>
          <div>
            <span>岩崎通信機株式会社、岩崎通信機株式会社の関係会社、共同開発元の株式会社grabss、および別表に記載の販売店</span>
            <a href="/Sharewind個人情報共同利用者.pdf" target="_blank">別表に記載の販売店</a>
          </div>
          <li>共同利用する目的</li>
          <ol class="sub">
            <li>本サービスに関する登録の受付、本人確認、利用料金の計算等、本サービスの提供、維持、保護及び改善のため</li>
            <li>本サービスの内容に関する情報、アップデート情報、イベント・キャンペーン情報、規約等の変更情報等の告知のため</li>
            <li>本サービスに関するご案内、お問い合わせ等への対応のため</li>
            <li>本サービスに関する当社の規約、その他諸規程に違反する行為への対応のため</li>
            <li>本サービスの利用に関する統計データを作成するため</li>
            <li>今後の本サービスに関する企画、立案又は実施のため</li>
            <li>本サービスを利用する際の、ログイン時又はまたはログイン後の本人認証のため</li>
            <li>キャンペーン等に当選されたお客様に賞品等を発送するため</li>
            <li>その他マーケティングに利用するため</li>
          </ol>
          <li>共同利用する情報の範囲</li>
          <div>氏名・会社名・住所・所属・電話番号・メールアドレス</div>
          <li>共同利用する個人情報の取得方法</li>
          <div>書面、ＷＥＢ、メールなど</div>
          <li>共同利用についての責任者</li>
          <div>岩崎通信機株式会社 個人情報保護管理者</div>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第8条 取得した個人情報の取扱の委託</div>
      <div class="article-body">取得した個人情報の取扱いの全部又は、一部を共同開発元の株式会社grabssに業務委託しております。</div>
    </div>
    <div class="article">
      <div class="article-title">第9条 個人情報の保持期間及び安全管理等</div>
      <div class="article-body">当社は、利用目的の達成に必要な範囲内において、個人データを、正確かつ最新の内容に保つとともに、法令で定められている保存期間が経過した場合、または第5条に定める利用目的の達成のために利用する必要がなくなった場合には、当該個人情報を遅滞なく消去するように努めます。また、取り扱う個人情報の漏えい、滅失又はき損の防止その他の個人情報の安全管理のために必要かつ適切な措置を講じます。</div>
    </div>
    <div class="article">
      <div class="article-title">第10条 個人情報の開示、訂正及び利用停止等</div>
      <div class="article-body">
        <ol>
          <li>当社は、お客様から、個人情報保護法の定めに基づき個人情報の開示を求められた場合には、個人情報保護法により当社が開示の義務がある場合に限り、お客様ご本人からの請求であることを確認の上で、遅滞なく個人情報の開示を行います。なお、個人情報の開示にあたっては、当社が別途定める手続きに従って開示手数料をお支払いいただく場合があります。</li>
          <li>当社は、お客様から、個人情報が真実でないという理由によって個人情報保護法の定めに基づきその内容の訂正を求められた場合、及び予め公表された利用目的の範囲を超えて取り扱われているという理由又は偽りその他不正の手段により取得されたものであるという理由によって個人情報保護法の定めに基づきその利用の停止を求められた場合には、お客様ご本人からの請求であることを確認の上で、遅滞なく必要な調査を行い、その結果に基づき、個人情報の内容の訂正又は利用停止を行い、お客様に対してその旨を通知します。</li>
          <li>当社は、お客様から、お客様の個人情報について消去を求められた場合には、当社が当該請求に応じる必要があると判断した場合に限り、お客様ご本人からの請求であることを確認の上で、遅滞なく個人情報の消去を行い、お客様に対してその旨を通知します。</li>
          <li>前各項の請求に際しては、次の内容その他当社所定の情報・資料を送付してください。</li>
          <ol class="sub">
            <li>氏名・住所・電話番号・メールアドレス</li>
            <li>請求内容・経緯・根拠資料</li>
            <li>本人確認資料</li>
          </ol>
          <li>以下の各号のいずれかに該当する場合は、第１項及び第２項の請求に応じることができない場合があります。その際は、お客様に対してその旨を通知すると共に、理由を説明します。</li>
          <ol class="sub">
            <li>お客様又は第三者の生命、身体、財産その他の権利利益を害するおそれがある場合</li>
            <li>当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合</li>
            <li>法令に違反することとなる場合</li>
            <li>お客様ご本人からの請求であることが確認できない場合</li>
          </ol>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第11条 サービス向上のための情報利用について</div>
      <div class="article-body">
        <div>当社は、本サービスの機能開発及び品質向上のため、お客様個人を特定できないよう、統計化または匿名加工した以下の情報を利用することがあります。但し、当社は通信の秘密を守る法律に則り、通信内容を厳格に保護しており、お客様同士のメッセージや画像・動画の内容、通話内容等を閲覧・利用することはありません。</div>
        <ol>
          <li>チャット利用に関する情報</li>
          <div>グループチャット数、メッセージ数、エモーティコン数、リアクション数、ファイル数、タスク作成情報、ビデオ通話・音声通話の利用状況、コンタクト管理情報、等を含みます。</div>
          <li>利用プランに関する情報</li>
          <div>契約内容、課金日、有効期限、等を含みます。</div>
          <li>アクティブユーザーに関する情報</li>
          <div>利用デバイス、OS、ブラウザ、等を含みます。</div>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第12条 改訂</div>
      <div class="article-body">当社は、本個人情報取扱規定を改訂することができ、お客様はこれを承諾するものとします。当社が別途定める場合を除き、本個人情報取扱規定の変更は、本サービスへの掲載によって随時お客様に発表するものとし、当該掲載をもって効力が生じます。</div>
    </div>
    <div class="privacy-policy-footer">以上</div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicyContent',
  props: {
    sm: Boolean
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";

.privacy-policy-content {
  font-size: 14px;
  line-height: 1.8em;

  @include mq(md) {
    font-size: 16px;
  }

  .heading {
    text-align: center;
    font-size: 1.5em;
    font-weight: 600;
    line-height: 1.3em;
    margin-bottom: 60px;

    @include mq(md) {
      font-size: 2em;
    }
  }

  &.sm {
    font-size: 12px;
    line-height: 1.6em;

    @include mq(md) {
      font-size: 14px;
    }

    .heading {
      font-size: 1.4em;
      line-height: 1.3em;
      margin-bottom: 40px;

      @include mq(md) {
        font-size: 1.6em;
      }
    }
  }
}

.article {
  margin-bottom: 20px;

  .article-title {
    font-weight: 600;
  }

  .article-body {
    padding-left: 14px;

    ol {
      padding-left: 16px;

      &.sub {
        margin: 5px 0;
        padding-left: 42px;
        list-style-type: none;
        counter-reset: cnt;

        > li::before {
          counter-increment: cnt;
          content: "(" counter(cnt) ")";
          width: 28px;
          margin-left: -28px;
          display: inline-block;
        }

        &.right-brackets > li::before {
          content: counter(cnt) ")";
          width: 24px;
          margin-left: -24px;
        }

        ul.hyphen {
          list-style-type: '-';
          padding-left: 4px;
          margin: 5px 0;

          li::before {
            content: "";
            width: 36px;
            margin-left: -28px;
            display: inline-block;
          }
        }
      }

      > ol.sub {
        padding-left: 24px;
      }
    }
  }
}

.privacy-policy-footer  {
  text-align: right;
  margin-top: 80px;
}
</style>
